import ensureComposeTabHandler from '../utils/composeTabHandler';
import { TabType, lazyAddTab, lazyActivateTab } from 'owa-tab-store';
import { action } from 'satcheljs/lib/legacy';
import { getStore } from '../store/composeStore';
import { findTabByData, lazySetTabIsShown } from 'owa-tab-store';
export default action('moveComposeToTab')(function (viewState, isShown, makeActive) {
    var tab = findTabByData(viewState);
    if (tab) {
        if (makeActive) {
            lazyActivateTab.importAndExecute(tab);
        }
        else {
            lazySetTabIsShown.importAndExecute(tab, isShown);
        }
    }
    else {
        var store = getStore();
        if (store.defaultViewState == viewState) {
            store.defaultViewState = null;
        }
        ensureComposeTabHandler();
        lazyAddTab.importAndExecute(TabType.Compose, isShown /*isShown*/, makeActive, viewState);
    }
});
//# sourceMappingURL=moveComposeToTab.js.map